import * as yup from 'yup';

export const schema = yup.object({
  des_modulo: yup.string().trim().required(),
});

export const schemaModal = yup.object({
  des_modulo_secao: yup.string().trim().required(),
});
